import {h, Fragment} from "preact"
import {Checkbox} from "./elements"

export default function FacetCheckboxItem({facet, toggleProductFilter}) {
    return (
        <ul class="ns-list-unstyled ns-p-0 ns-m-0 ss__list facets-layout facets-layout-list facets-layout-list--text presentation-text list-unstyled facets__list--vertical" role="menu">
            {facet.data?.map(value => (
                <li
                    key={value.value}
                    class="ns-d-flex ns-justify-content-between ns-align-items-center ns-font-3 list-menu__item facets__item"
                    data-nosto-element="facet-setting"
                    role="menuitem"
                >
                    <Checkbox
                        value={value.value}
                        selected={value.selected}
                        onChange={e => {
                            e.preventDefault()
                            toggleProductFilter(facet.field, value.value, !value.selected)
                        }}
                    />
                </li>
            ))}
        </ul>
    )
}